import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const DescriptionBox = styled.div`
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px;
  padding: 20px 15px;
`;

export const TextBox = styled.div<{ $isOpen?: boolean }>`
  display: grid;
  grid-template-rows: ${({ $isOpen }) => ($isOpen ? '1fr' : '0fr')};
  overflow: hidden;
`;

export const Text = styled(Typography.Body)<{ $maxHeight: number }>`
  max-height: ${({ $maxHeight }) => $maxHeight}px;
  white-space: pre-line;
  word-break: break-word;
`;

export const Toggle = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.blue};
  text-decoration: underline;
  max-width: max-content;
`;
